/* Shared checkout is opt-in only when this browser has pending print setups. */
(() => {
  if (window.__arteefyPrintCartBridge) return;
  window.__arteefyPrintCartBridge = true;
  const target = '/apps/maker/by-size/cart';
  let combinedEnabled = false;
  const pending = () => {
    try { return JSON.parse(localStorage.getItem('arteefy-print-cart-v1') || '[]').length > 0 || (combinedEnabled && JSON.parse(localStorage.getItem('arteefy-gang-cut-cart-v1') || '[]').length > 0); }
    catch { return true; }
  };
  // All Dawn/embedded-app fetch mutations use the same cross-tab lock as paid
  // cart reconciliation, so a later add cannot be overwritten by its cleanup.
  const nativeFetch = window.fetch.bind(window);
  const token = localStorage.getItem('mk_session');
  nativeFetch('/apps/maker/by-size/api/by-size/checkout/status', {cache:'no-store',headers:token?{'X-Maker-Session':token}:{}})
    .then(r => r.ok ? r.json() : {}).then(data => { combinedEnabled = !!data.unified_cart; refresh(); }).catch(() => {});
  window.fetch = (input, init) => {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
    const method = (init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    const headers = new Headers(init?.headers || (input instanceof Request ? input.headers : undefined));
    // Shared-cart callers already own this non-reentrant Web Lock.
    const alreadyLocked = headers.get('X-ARTeefy-Cart-Locked') === '1';
    if (navigator.locks && !alreadyLocked && url.origin === location.origin && method === 'POST' && /^\/cart\/(add|change|update|clear)(?:\.js)?$/.test(url.pathname)) {
      return navigator.locks.request('arteefy-print-cart', () => nativeFetch(input, init));
    }
    return nativeFetch(input, init);
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !pending()) return;
    const button = event.submitter;
    if (button?.getAttribute('name') === 'checkout' || form.getAttribute('action') === '/checkout') {
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(target);
    }
  }, true);
  document.addEventListener('click', event => {
    const element = event.target instanceof Element ? event.target.closest('a,button,input') : null;
    if (!element || !pending()) return;
    const href = element.getAttribute('href');
    if (element.getAttribute('name') === 'checkout' || href === '/checkout' || href === '/cart' || href === '/cart/') {
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(target);
    }
  }, true);
  const hiddenPayments = new Map();
  function refresh() {
    const active = pending();
    document.querySelectorAll('.cart__dynamic-checkout-buttons,.additional-checkout-buttons,shopify-accelerated-checkout-cart').forEach(node => {
      if (active) { if (!hiddenPayments.has(node)) hiddenPayments.set(node, node.hidden); if (!node.hidden) node.hidden = true; }
      else if (hiddenPayments.has(node)) { node.hidden = hiddenPayments.get(node); hiddenPayments.delete(node); }
    });
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    const previous = document.getElementById('arteefy-print-cart-notice');
    if (!active) { previous?.remove(); return; }
    if (previous) return;
    const band = document.createElement('div');
    band.id = 'arteefy-print-cart-notice';
    band.style.cssText = 'padding:16px 20px;background:#edf8fc;border-top:2px solid #92c6d9;color:#203b45;margin:16px auto;max-width:1100px;box-sizing:border-box;font-size:15px';
    const text = document.createElement('span');
    text.textContent = 'Your custom prints and store items are ready to review together. ';
    const link = document.createElement('a');
    link.href = target; link.textContent = 'View cart & checkout';
    link.style.cssText = 'color:#08635f;font-weight:700;text-decoration:underline;display:inline-block;min-height:36px;line-height:36px';
    band.append(text, link);
    (document.querySelector('main') || document.body).prepend(band);
    // Accelerated native checkout cannot include tool snapshots; retain it
    // untouched for all other carts and expose the combined checkout instead.
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true}); else refresh();
  window.addEventListener('storage', refresh);
  window.addEventListener('arteefy:cart', refresh);
  window.addEventListener('pageshow', refresh);
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true; requestAnimationFrame(() => { scheduled = false; refresh(); });
  }).observe(document.documentElement, {childList:true, subtree:true});
})();
